import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class DefaultDashboardService {
  public id: BehaviorSubject<number> = new BehaviorSubject(null);

  constructor() {
  }

}
